import { useEffect, useState } from 'react';
import getFormatMessage from '../../../locales/get-format-message';
import { IComponentProps } from '../../../model/studio';
import { BillingMenuComponent } from './billing-menu';
import BillingIcon from '../../../assets/svg/billing-blue.svg';
import RechargeIcon from '../../../assets/svg/recharge-icon.svg';
import './index.scss';
import { BillingOverviewComponent } from '../../component/billing-center/billing-overview';
import { AccountManagement } from '../../component/billing-center/account-management';
import { BillingManagement } from '../../component/billing-center/billing-management';
import { RechargeComponent } from '../../component/billing-center/billing-overview/component/recharge';
import { WithdrawalComponent } from '../../component/billing-center/billing-overview/component/withdrawal';
import { TransactionDetailsComponent } from '../../component/billing-center/billing-overview/component/transaction-details';
import { useHistory } from 'react-router-dom';
import { IBillingAccountInfo } from '../../../model/billing-center';
import { OrderManage } from '../../component/billing-center/order-management';
import { OrderDetail } from '../../component/billing-center/order-management/detail';
import {
  CommonStatusStep,
  StudioCertifiedType,
} from '../../../model/api-modules';
import { GuideCompanyComponent } from '../../component/billing-center/billing-overview/component/guide-to-company';
import { getAccountInfo } from '../../../api';
import { InvoiceManage } from '../../component/billing-center/invoice-mangement';
import { getConfig } from '../../../config';
import { DeployArea } from '../../../model';
import { wrapTimeReport } from '../../lib/bk-report';

interface IProps extends IComponentProps {}

export const BillingContentComponent = (props: IProps) => {
  const [selectedNavItemKey, setSelectedNavItemKey] = useState<string>('');
  const [navPath, setNavPath] = useState<string[]>([]);

  // const [contentToRender, setContentToRender] = useState<any>(null);
  const { companyInfo } = props;
  // 企业认证后才能访问
  const [showNotCompany, setShowNotCompany] = useState<boolean>(
    companyInfo?.Status !== CommonStatusStep.Resolve
  );
  // 内部认证工作室
  const [isInternalCert, setIsInternalCert] = useState<boolean>(
    companyInfo?.certifiedType === StudioCertifiedType.InternalKpiCode
  );
  const [balanceList, setBalanceList] =
    useState<Readonly<IBillingAccountInfo | null>>(null);
  const history = useHistory();
  const navItems = [
    {
      name: getFormatMessage('billing_overview'),
      key: 'billing_overview',
      content: balanceList && (
        <BillingOverviewComponent
          studioInfo={props.studioInfo}
          balanceList={balanceList}
          members={props.members}
        />
      ),
      pathname: '/studio/:studioId/fee/overview',
    },
    {
      name: getFormatMessage('account_management'),
      key: 'account_management',
      content: (
        <AccountManagement
          studioId={props.studioInfo.studio.StudioID}
          balanceList={balanceList}
          studioName={props.studioInfo.studio.Name}
        />
      ),
      pathname: '/studio/:studioId/fee/account-manage',
    },
    {
      name: getFormatMessage('order_management'),
      key: 'order_management',
      content: <OrderManage />,
      pathname: '/studio/:studioId/fee/order-manage',
    },
    {
      name: getFormatMessage('billing_management'),
      key: 'billing_management',
      content: <BillingManagement studioInfo={props.studioInfo} />,
      pathname: '/studio/:studioId/fee/billing-manage',
    },
    {
      name: getFormatMessage('invoice_manage'),
      key: 'invoice_management',
      content: <InvoiceManage companyInfo={companyInfo} owner={props.owner} />,
      pathname: '/studio/:studioId/fee/invoice-manage',
    },
  ];

  const onClickNav = (key: string, pathname: string) => {
    return () => {
      const selectedNav = navItems.find((item) => item.key === key);
      if (key && balanceList) {
        const updatedPathname = pathname.replace(
          ':studioId',
          props.studioInfo.studio.StudioID
        );
        setSelectedNavItemKey(key);
        if (selectedNav) {
          setNavPath([selectedNav.name]);
        }
        history.push(updatedPathname);
      }
    };
  };

  const init = async () => {
    if (!props.studioInfo.studio.StudioID) {
      return;
    }
    const res = await getAccountInfo(props.studioInfo.studio.StudioID);
    if (res) {
      setBalanceList(res);
    }
  };

  useEffect(() => {
    setShowNotCompany(!companyInfo?.isCertified);
    setIsInternalCert(
      companyInfo?.certifiedType === StudioCertifiedType.InternalKpiCode
    );
  }, [companyInfo?.Status]);
  useEffect(() => {
    wrapTimeReport(init);
  }, [selectedNavItemKey]);
  const currentPath = window.location.href;
  useEffect(() => {
    if (balanceList) {
      const currentPath = window.location.pathname;
      const selectedItem = navItems.find((item) => {
        const regex = new RegExp(
          item.pathname.replace(':studioId', props.studioInfo.studio.StudioID)
        );
        return regex.test(currentPath);
      });
      // 找到匹配的导航项selectedItem
      if (selectedItem) {
        setSelectedNavItemKey(selectedItem.key);
        setNavPath([selectedItem.name]);
      }
    }
  }, [balanceList, currentPath]);

  useEffect(() => {
    // 子页面-头部nav信息展示
    if (selectedNavItemKey === 'billing_overview') {
      if (currentPath.endsWith('/recharge')) {
        console.log('nav设置成功222222', ...navPath);
        setNavPath([...navPath, getFormatMessage('recharge_nav')]);
      } else if (currentPath.endsWith('/withdrawal')) {
        setNavPath([...navPath, getFormatMessage('withdrawal')]);
      } else if (currentPath.endsWith('/transaction-details')) {
        setNavPath([...navPath, getFormatMessage('balance')]);
      }
    }
    if (selectedNavItemKey === 'order_management') {
      if (currentPath.includes('/order-manage/detail')) {
        setNavPath([...navPath, getFormatMessage('order_detail')]);
      }
    }
    if (selectedNavItemKey === 'invoice_management') {
      if (currentPath.includes('/invoice-manage/history')) {
        setNavPath([...navPath, getFormatMessage('invoice_history')]);
      }
      if (currentPath.includes('/invoice-manage/apply')) {
        setNavPath([...navPath, getFormatMessage('apply_invoice')]);
      }
    }
  }, [selectedNavItemKey, balanceList, currentPath]);

  const gotoParent = (name: string) => {
    const navItem = navItems.find((item) => item.name === name);
    if (navItem) {
      const updatedPathname = navItem.pathname.replace(
        ':studioId',
        props.studioInfo.studio.StudioID
      );
      console.log('navItem.name11', navItem.name);
      setNavPath([navItem.name]);
      history.push(updatedPathname);
    }
  };

  const renderContent = () => {
    if (companyInfo === undefined) {
      return null;
    }

    if (showNotCompany) {
      return (
        <GuideCompanyComponent studioId={props.studioInfo.studio.StudioID} />
      );
    }

    if (getConfig().deployArea === DeployArea.woa) {
      return (
        <GuideCompanyComponent
          warnText={getFormatMessage('bill_internal_cert_desc')}
          studioId={props.studioInfo.studio.StudioID}
        />
      );
    }

    if (getConfig().deployArea === DeployArea.singapore) {
      return (
        <GuideCompanyComponent
          warnText={getFormatMessage('bill_intl_site_desc')}
          studioId={props.studioInfo.studio.StudioID}
        />
      );
    }

    if (isInternalCert) {
      return (
        <GuideCompanyComponent
          warnText={getFormatMessage('bill_internal_cert_desc')}
          studioId={props.studioInfo.studio.StudioID}
        />
      );
    }

    if (selectedNavItemKey === 'billing_overview') {
      if (currentPath.endsWith('/recharge')) {
        return (
          <RechargeComponent
            studioInfo={props.studioInfo}
            balanceList={balanceList}
          />
        );
      }
      if (currentPath.endsWith('/withdrawal')) {
        return (
          <WithdrawalComponent
            studioInfo={props.studioInfo}
            balanceList={balanceList}
            onUpdate={init}
            companyName={companyInfo?.Name}
          />
        );
      }
      if (currentPath.endsWith('/transaction-details')) {
        return <TransactionDetailsComponent studioInfo={props.studioInfo} />;
      }
    }
    if (
      selectedNavItemKey === 'order_management' &&
      currentPath.includes('/order-manage/detail')
    ) {
      return <OrderDetail />;
    }

    return (
      navItems.find((navItem) => navItem.key === selectedNavItemKey)?.content ||
      null
    );
  };
  const uniqueNavPath = Array.from(new Set(navPath));
  return (
    <>
      <div className="billing-container">
        <div className="billing-top">
          <div className="billing-line"></div>
          <div className="current-nav-item">
            {getFormatMessage('cost_center')}
            {uniqueNavPath.map((pathName, pathIndex) => {
              const isLast = pathIndex === uniqueNavPath.length - 1;
              return (
                <span key={pathIndex}>
                  <span className="current-nav-line">/</span>
                  <span
                    onClick={() => gotoParent(pathName)}
                    className={`${
                      isLast ? 'last-nav-name' : 'current-nav-name'
                    }`}
                  >
                    {isLast && uniqueNavPath.length > 1 && (
                      <img
                        className="child-nav-icon"
                        src={RechargeIcon}
                        width={14}
                        height={14}
                      />
                    )}
                    <span>{pathName}</span>
                  </span>
                </span>
              );
            })}
          </div>
        </div>

        <div className="billing-bottom">
          <div className="billing-nav-list">
            <div className="billing-nav-name">
              <img src={BillingIcon} className="billing-blue-icon" />
              {getFormatMessage('cost_center')}
            </div>
            <BillingMenuComponent
              navItems={navItems}
              selectedNavItem={selectedNavItemKey}
              onClickNav={onClickNav}
              studioInfo={props.studioInfo}
            />
          </div>
          <div className="billing-content">{renderContent()}</div>
        </div>
      </div>
    </>
  );
};
